var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.475 14.9992V14.8992H9.375H1.25C0.617696 14.8992 0.1 14.3815 0.1 13.7498V3.12109C0.1 2.48885 0.618321 1.97109 1.25 1.97109H18.75C19.3817 1.97109 19.9 2.48885 19.9 3.12109V13.7498C19.9 14.3814 19.3817 14.8992 18.75 14.8992H10.625H10.525V14.9992V16.878V16.978H10.625H13.75C14.0398 16.978 14.275 17.2132 14.275 17.503C14.275 17.7927 14.0398 18.028 13.75 18.028H6.25C5.96023 18.028 5.725 17.7927 5.725 17.503C5.725 17.2132 5.96023 16.978 6.25 16.978H9.375H9.475V16.878V14.9992ZM18.75 13.8498H18.85V13.7498V3.12109V3.02109H18.75H1.25H1.15V3.12109V13.7498V13.8498H1.25H18.75Z",
    fill: "#6B6B6B",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0697 11.4587C10.0891 11.3235 10.2103 11.2314 10.3387 11.2314H11.8203C12.776 11.2314 13.5669 10.3872 13.5669 9.33149C13.5669 8.2758 12.776 7.4316 11.8203 7.4316H7.14343L8.35457 8.6442L8.35638 8.64601L8.35636 8.64604C8.45463 8.74962 8.45463 8.91177 8.35636 9.01535L8.35545 9.01631L8.35544 9.01631C8.2533 9.12114 8.08567 9.12277 7.97996 9.02236L7.97809 9.02059L7.97812 9.02056L6.31153 7.35398C6.20748 7.24993 6.20748 7.08162 6.31153 6.97757L7.97812 5.31099L7.97997 5.30913L7.98 5.30916C8.08358 5.21088 8.24573 5.21088 8.34931 5.30916L8.35028 5.31007L8.35027 5.31007C8.4551 5.41221 8.45673 5.57985 8.35632 5.68556L8.35455 5.68742L8.35452 5.6874L7.14364 6.89829H11.8203C13.0834 6.89829 14.1002 7.99619 14.1002 9.3315C14.1002 10.6668 13.0834 11.7647 11.8203 11.7647H10.3337C10.1739 11.7647 10.0459 11.6235 10.0697 11.4587ZM10.0697 11.4587C10.0697 11.4587 10.0697 11.4587 10.0697 11.4587L10.1687 11.473L10.0697 11.4589C10.0697 11.4588 10.0697 11.4588 10.0697 11.4587Z",
    fill: "#6B6B6B",
    stroke: "#6B6B6B",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardIcon);
export default __webpack_public_path__ + "static/media/onboardIcon.9015d3f0b58c1f63a74b5cb0cf5d0ba3.svg";
export { ForwardRef as ReactComponent };